"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LabelNode = exports.Label = exports.Check = exports.CheckBox = exports.CheckBoxInputContainer = exports.ViewContainer = void 0;
/* eslint-disable sonarjs/no-identical-functions */
const native_1 = __importStar(require("styled-components/native"));
exports.ViewContainer = native_1.default.View `
  flex-direction: column;
`;
exports.CheckBoxInputContainer = native_1.default.View `
  flex-basis: auto;
  flex-direction: row;
`;
exports.CheckBox = native_1.default.View `
  flex-basis: 24px;
  height: 24px;
  width: 24px;
  border: 1px solid
    ${({ checked, theme, type }) => checked
    ? // @ts-ignore
        theme.checkBox[type].checked.borderColor
    : // @ts-ignore
        theme.checkBox[type].borderColor};
  border-radius: 4px;
  background-color: ${({ checked, theme, type }) => checked
    ? // @ts-ignore
        theme.checkBox[type].checked.backgroundColor
    : // @ts-ignore
        theme.checkBox[type].backgroundColor};
`;
exports.Check = native_1.default.View `
  padding: 12.5%;
`;
exports.Label = native_1.default.Text `
  flex-shrink: 1;
  margin: auto 0;
  margin-left: 16px;
  ${({ theme }) => native_1.css `
      font-size: ${theme.card['text-medium'].size};
      line-height: ${theme.card['text-medium'].lineHeight};
    `}
`;
exports.LabelNode = native_1.default.View `
  flex-shrink: 1;
  margin: auto 0;
  margin-left: 16px;
  ${({ theme }) => native_1.css `
      font-size: ${theme.card['text-medium'].size};
      line-height: ${theme.card['text-medium'].lineHeight};
    `}
`;
